document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bh-products').forEach(function (section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bh-tab]');
      if (!btn || !section.contains(btn)) return;
      var key = btn.getAttribute('data-bh-tab');
      section.querySelectorAll('[data-bh-tab]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      section.querySelectorAll('[data-bh-panel]').forEach(function (p) {
        var active = p.getAttribute('data-bh-panel') === key;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
    });
  });
});
